import React from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { Typography } from "@mui/material";
import QuestionnaireFormCRUDTable from "../../components/CRUD/Tables/QuestionnaireFormCRUDTable";

const IQLS = () => {
    return (
        <DashboardLayout>
            <Typography variant="h4" component="h1" gutterBottom>
                IQLS - Формы анкет
            </Typography>
            <QuestionnaireFormCRUDTable />
        </DashboardLayout>
    );
};

export default IQLS;
